import React, { useEffect, useState } from 'react';
import { API_URL, apiFetch } from '../../../config/api';
import { Message } from '../../../types/flzhub';
import { Badge, Card, getAgentColor, getAgentInitials, getRoleBadgeColor, getRoleTitle } from './Shared';

interface Props {
  messages: Message[]; // fallback
}

export const FlzStories: React.FC<Props> = ({ messages }) => {
  const [stories, setStories] = useState<Message[]>([]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await apiFetch(`${API_URL}/api/flzhub/stories?limit=50`);
        const data = await res.json() as { stories?: Message[] };
        if (data.stories && data.stories.length > 0) {
          setStories(data.stories);
        } else {
          // Fallback: filter from parent messages by story types
          setStories(messages.filter(m =>
            ['yumurta_story', 'baba_topic', 'story', 'anne_roaming_report',
             'anne_intervention', 'baba_response', 'expert_response', 'anne_response',
             'character_intro'].includes(m.message_type) || m.message.length > 200
          ).slice(0, 50));
        }
      } catch {
        setStories(messages.filter(m =>
          ['yumurta_story', 'baba_topic', 'anne_intervention', 'baba_response',
           'expert_response', 'anne_response', 'character_intro'].includes(m.message_type) || m.message.length > 200
        ).slice(0, 50));
      }
    };
    load();
  }, [messages]);

  return (
    <div style={{ height: '100%', overflowY: 'auto', padding: 16, display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12, alignContent: 'start' }}>
      {stories.length === 0 && <div style={{ gridColumn: '1/-1', textAlign: 'center', color: 'var(--os-muted)', padding: 40, fontSize: 12 }}>No stories yet</div>}
      {stories.map(m => {
        const color = getRoleBadgeColor(m.agent_id);
        return (
          <Card key={m.id} style={{ borderTop: `3px solid ${color}`, display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
              <Badge color={color}>{getRoleTitle(m.agent_id)}</Badge>
              <span style={{ fontSize: 9, color: 'var(--os-muted)' }}>{m.created_at ? new Date(m.created_at).toLocaleDateString() : ''}</span>
            </div>
            <div style={{ fontSize: 11, lineHeight: 1.6, flex: 1, color: 'rgba(255,255,255,0.85)' }}>{m.message.slice(0, 300)}{m.message.length > 300 ? '...' : ''}</div>
            <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: 6, paddingTop: 8, borderTop: '1px solid rgba(255,255,255,0.05)' }}>
              <div style={{ width: 18, height: 18, borderRadius: '50%', background: getAgentColor(m.agent_name), color: '#fff', fontSize: 8, fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {getAgentInitials(m.agent_name)}
              </div>
              <span style={{ fontSize: 10, fontWeight: 600 }}>{m.agent_name}</span>
              {m.eq_score != null && <span style={{ marginLeft: 'auto', fontSize: 9, color: '#10b981' }}>EQ {m.eq_score.toFixed(1)}</span>}
            </div>
          </Card>
        );
      })}
    </div>
  );
};
